<div *ngIf="titleObject" [title]="titleObject.title | translate | uppercase"
  [class.title-with-yellow]="!titleObject.isChildren" [class.title-navigation-back]="titleObject.isChildren"
  (click)="titleObject.isChildren && goBack()">
  <mat-icon *ngIf="titleObject.isChildren">arrow_back</mat-icon>
  <span [ngClass]="{'mat-h1': !titleObject.isChildren, 'subtitle': titleObject.isChildren}"
    style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">
    {{ titleObject.title | translate | uppercase }}
  </span>
</div>